import React from "react";
import Div100vh from "react-div-100vh";

import SearchIcon from "@/assets/icons/search-icon.svg";
import GoBackButton from "@/components/common/buttons/GoBackButton";

const referData = [];

export default function ReferHistoryScreen() {
  return (
    <Div100vh className="relative flex flex-col overflow-hidden justify-between">
      <div className="flex flex-col gap-12 p-10">
        <div className="flex justify-between">
          <GoBackButton />
          <button>
            <img src={SearchIcon} alt="search" />
          </button>
        </div>
        <div className="flex flex-col justify-center gap-8">
          <span>Refer History</span>
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <table className="">
              <tbody className="text-[#999999] text-lg">
                {referData.map((data, index) => (
                  <tr key={index} className="border-b-2 border-[#555555]">
                    <td scope="row" className="px-6 py-4">
                      {data.name}
                    </td>
                    <td className="px-6 py-4 text-[#eeeeee]">{data.number}</td>
                    <td className="pl-32 py-4">{data.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-start p-10 text-lg gap-8 justify-between bg-[#222222]">
        <div className="flex flex-col gap-4">
          <span className="text-[#eeeeee]">
            Refer a landlord or tenant & get ₹500
          </span>
          <span className="text-[#999999] text-base">
            Invite your friends to CirclePe Club & earn 500 INR every time
            someone rents via our platform
          </span>
        </div>
        <button className="w-full border py-2 bg-white text-black font-semibold text-lg">
          Share
        </button>
      </div>
    </Div100vh>
  );
}
